import { render, staticRenderFns } from "./BudgetApp.vue?vue&type=template&id=46ec216b&scoped=true"
import script from "./BudgetApp.vue?vue&type=script&lang=js"
export * from "./BudgetApp.vue?vue&type=script&lang=js"
import style0 from "./BudgetApp.vue?vue&type=style&index=0&id=46ec216b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ec216b",
  null
  
)

export default component.exports